import React from "react";
import { Auth } from 'aws-amplify';
import { Avatar, Box, Drawer } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { getBottomMenuItems, SIDE_BAR_LINKS, THEME_MODES } from "../../helpers/constant";
import { useThemeMode } from "../../components/theme";
import LogoWhite from "../../pages/images/logo-white.png";
import { colours as constColours } from "../../consts";

const CustomDrawer = ({
    sizeOfMenuDrawer,
    isAdmin,
    ProjectVersion,
    mobileOpen,
    handleDrawerTransitionEnd,
    handleDrawerClose,
}) => {
    const location = useLocation();
    const { colours, themeMode, FONT } = useThemeMode();

    const drawer = (
        <nav
            aria-label="Sidebar Navigation"
            style={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                background: "#000",
                overflow: "hidden",
            }}
        >
            <Box height={80} boxSizing="border-box" display="flex" flexDirection="column" borderBottom="1px solid rgba(255,255,255,.25)" flexShrink={0}>
                <Avatar alt="Vocalysd Logo" sx={{ width: 48, height: 48, m: 'auto' }} src={LogoWhite} variant="square" />
            </Box>
            <div
                style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    background: "#000",
                    overflow: "auto",
                    flexGrow: 1,
                }}
            >
                {SIDE_BAR_LINKS.map((item) => (
                    <Link
                        key={item.to}
                        to={item.to}
                        style={{ ...(location.pathname === item.to || item.linkedPages.includes(location.pathname)) ? colours.menuStyleSelected : colours.menuStyle, fontSize: FONT.SIZE_12, color: (themeMode === THEME_MODES.LIGHT || themeMode === THEME_MODES.COLOR_VISION) ? colours.white : colours.black }}
                    >
                        {item.icon}
                        {item.name}
                    </Link>
                ))}
                <div style={{ marginTop: "auto" }}>
                    {getBottomMenuItems(isAdmin).map((item) => (
                        <Link key={item.to} to={item.to} onClick={() => item.signOut ? Auth.signOut() : {}} style={{ ...(location.pathname === item.to || item.linkedPages.includes(location.pathname)) ? colours.menuStyleSelected : colours.menuStyle, fontSize: FONT.SIZE_12, color: (themeMode === THEME_MODES.LIGHT || themeMode === THEME_MODES.COLOR_VISION) ? colours.white : colours.black }}>
                            {item.icon}
                            {item.name}
                        </Link>
                    ))}
                    <div
                        style={{
                            color: themeMode === THEME_MODES.HIGH_CONTRAST ? colours.black : constColours.white,
                            fontSize: FONT.SIZE_12,
                            textAlign: "center",
                            marginTop: 8,
                            marginBottom: 8,
                        }}
                    >
                        {"v" + ProjectVersion}
                    </div>
                    <div
                        style={{
                            width: "50%",
                            margin: "auto",
                            marginBottom: 8,
                            borderTop: `1px solid ${themeMode === THEME_MODES.HIGH_CONTRAST ? colours.black : constColours.white}`,
                            textAlign: "center",
                        }}
                    />
                    <Link
                        to="/privacy"
                        style={{
                            textDecoration: "none",
                            color: themeMode === THEME_MODES.HIGH_CONTRAST ? colours.black : constColours.white,
                            fontSize: FONT.SIZE_10,
                            display: "block",
                            textAlign: "center",
                            marginTop: 8,
                            marginBottom: 16,
                        }}
                    >
                        Privacy Policy
                    </Link>
                </div>
            </div>
        </nav>
    );
    return (
        <React.Fragment>
            <Drawer
                anchor={"left"}
                variant="temporary"
                open={mobileOpen}
                onTransitionEnd={handleDrawerTransitionEnd}
                onClose={handleDrawerClose}
                ModalProps={{
                    keepMounted: true,
                }}
                sx={{
                    display: { xs: "block", md: "none" },
                    "& .MuiDrawer-paper": {
                        boxSizing: "border-box",
                        width: sizeOfMenuDrawer,
                    },
                }}
            >
                {drawer}
            </Drawer>
            <Drawer
                variant="permanent"
                sx={{
                    display: { xs: "none", md: "block" },
                    "& .MuiDrawer-paper": {
                        boxSizing: "border-box",
                        width: sizeOfMenuDrawer,
                        borderRightWidth: 0,
                    },
                }}
                open
            >
                {drawer}
            </Drawer>
        </React.Fragment>
    );
};

export default CustomDrawer;
